<div style="padding:30px">
    <div class="datebg" style="display: flex;">
        <div class="inner-content">
            <div style="margin-right: 30%">
                <select class="form-control"
                    style="width: 160px;display: inline-block;"
                    [(ngModel)]="data_view_list_act"
                    (change)="disable();init_list()"
                >
                    <option *ngFor="let item of data_view_list" [ngValue]="item.id">{{item.name}}</option>
                </select>
            </div>

            <div class="dateSetting" *ngIf="data_view_list_act == '2'">
                <input type="text" class="form-control"  [(ngModel)] ="monthRange" style="width: 260px;display: inline-block;margin-right: 16px;" (click)="openMonth()">
                <month-picker *ngIf="openMonthdata" (monthRangeSelected)="disable();logRange($event)" (status)="closeMonth()"></month-picker>
            </div>

            <div class="datearea"  *ngIf="data_view_list_act == '1'">
                <input type="text"
                *ngIf="time"
                class="form-control"
                 ngxDaterangepickerMd
                 [(ngModel)]="time"
                 [autoApply]="true"
                [ranges]="ranges" [alwaysShowCalendars]="true"
                [locale]="{applyLabel: 'ok', format: 'YYYY-MM-DD'}"
                [opens]="'right'"
                [minDate]="time.minDate"
                [maxDate]='time.maxDate'
                (change)="disable();onRangeSelected(1,$event)"
                (blur)="onDateTyped($event)"
                style="width: 260px;display: inline-block;margin-right: 16px;"
                >
            </div>
        </div>
    </div>

    <mat-form-field>
        <mat-label>選擇呈現類別</mat-label>
        <mat-select [(ngModel)]="local_filtera" multiple (ngModelChange)="fresh_show_dataArray(local_filtera)">
            <mat-option *ngFor="let item of groupName" [value]="item.name">{{ item.name }}</mat-option>
        </mat-select>
    </mat-form-field>

    <hr>

    <div
        cdkDropList
        cdkDropListOrientation="horizontal"
        class="button-container"
        (cdkDropListDropped)="drop($event)"
    >
        <button cdkDrag
            *ngFor="let item of local_config; let i = index"
            (click)="fresh_show_data(item)"
            class="btn btn-primary"
            style="margin: 10px;"
        >
            {{ item }}
        </button>
    </div>

    <app-table-v2  *ngIf="datav2.length>0" [type]="1"  [titleTableName]="titleTableName" [titleTableContent] = "titleTableContent" [pagecount]="pagecount"    [tcontent]="tcontent" [data]="datav2" [aSum]="aSum"  [loadmore] = "1"  (packet)="handlepacket($event)">
        <ng-template let-post #operation_dk>
            <p>{{post.val[post.key]}}</p>
            <p *ngIf="post.val[post.key+'_cal'] == undefined || post.val[post.key+'_cal'] == null || post.val[post.key+'_cal'] == 0.00">0%</p>
            <p  *ngIf="post.val[post.key+'_cal'] < 0" style="color:green">{{post.val[post.key+'_cal']}}%</p>
            <p  *ngIf="post.val[post.key+'_cal'] > 0" style="color:red">{{post.val[post.key+'_cal']}}%</p>
        </ng-template>
    </app-table-v2>
    <!-- <app-pagnation (callback)="callback($event)" [data]="pageobjstr"></app-pagnation>  -->

    <a *ngIf="showbacktop"  (click)="go_top()" id="go_top" onclick="return false" class="back-to-top"> <i style="font-size: 1.73em;" class="fas fa-arrow-circle-up"></i> </a>
</div>


<app-spinner [loading]="loading"></app-spinner>


